import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _14d483a8 = () => interopDefault(import('../pages/404-path.vue' /* webpackChunkName: "pages/404-path" */))
const _6acda544 = () => interopDefault(import('../pages/agb.vue' /* webpackChunkName: "pages/agb" */))
const _60a548ca = () => interopDefault(import('../pages/benachrichtigungen.vue' /* webpackChunkName: "pages/benachrichtigungen" */))
const _984fb542 = () => interopDefault(import('../pages/bibliothek.vue' /* webpackChunkName: "pages/bibliothek" */))
const _3e2f7805 = () => interopDefault(import('../pages/datenschutz.vue' /* webpackChunkName: "pages/datenschutz" */))
const _6c1b9098 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _45de6d1f = () => interopDefault(import('../pages/einstellungen.vue' /* webpackChunkName: "pages/einstellungen" */))
const _53ba4728 = () => interopDefault(import('../pages/hilfe.vue' /* webpackChunkName: "pages/hilfe" */))
const _4d1a4fd9 = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _d8cc4a6a = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _29547010 = () => interopDefault(import('../pages/profiles.vue' /* webpackChunkName: "pages/profiles" */))
const _7e4a7110 = () => interopDefault(import('../pages/raisenow.vue' /* webpackChunkName: "pages/raisenow" */))
const _1e8f5051 = () => interopDefault(import('../pages/registrieren.vue' /* webpackChunkName: "pages/registrieren" */))
const _53ced02a = () => interopDefault(import('../pages/team.vue' /* webpackChunkName: "pages/team" */))
const _4d7acd91 = () => interopDefault(import('../pages/pfad/ai-neu.vue' /* webpackChunkName: "pages/pfad/ai-neu" */))
const _4cf4d436 = () => interopDefault(import('../pages/pfad/neu.vue' /* webpackChunkName: "pages/pfad/neu" */))
const _b9ca8222 = () => interopDefault(import('../pages/pfad/_ref/index.vue' /* webpackChunkName: "pages/pfad/_ref/index" */))
const _68028c30 = () => interopDefault(import('../pages/profil/_username.vue' /* webpackChunkName: "pages/profil/_username" */))
const _56ebda28 = () => interopDefault(import('../pages/pfad/_ref/admin.vue' /* webpackChunkName: "pages/pfad/_ref/admin" */))
const _594b2582 = () => interopDefault(import('../pages/pfad/_ref/editAdmin.vue' /* webpackChunkName: "pages/pfad/_ref/editAdmin" */))
const _68e14386 = () => interopDefault(import('../pages/pfad/_ref/vorschau.vue' /* webpackChunkName: "pages/pfad/_ref/vorschau" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-path",
    component: _14d483a8,
    name: "404-path___de___default"
  }, {
    path: "/agb",
    component: _6acda544,
    name: "agb___de___default"
  }, {
    path: "/benachrichtigungen",
    component: _60a548ca,
    name: "benachrichtigungen___de___default"
  }, {
    path: "/bibliothek",
    component: _984fb542,
    name: "bibliothek___de___default"
  }, {
    path: "/datenschutz",
    component: _3e2f7805,
    name: "datenschutz___de___default"
  }, {
    path: "/de",
    component: _6c1b9098,
    name: "index___de"
  }, {
    path: "/einstellungen",
    component: _45de6d1f,
    name: "einstellungen___de___default"
  }, {
    path: "/fr",
    component: _6c1b9098,
    name: "index___fr"
  }, {
    path: "/hilfe",
    component: _53ba4728,
    name: "hilfe___de___default"
  }, {
    path: "/impressum",
    component: _4d1a4fd9,
    name: "impressum___de___default"
  }, {
    path: "/login",
    component: _d8cc4a6a,
    name: "login___de___default"
  }, {
    path: "/profile",
    component: _29547010,
    name: "profiles___de___default"
  }, {
    path: "/raisenow",
    component: _7e4a7110,
    name: "raisenow___de___default"
  }, {
    path: "/registrieren",
    component: _1e8f5051,
    name: "registrieren___de___default"
  }, {
    path: "/team",
    component: _53ced02a,
    name: "team___de___default"
  }, {
    path: "/de/404-path",
    component: _14d483a8,
    name: "404-path___de"
  }, {
    path: "/de/agb",
    component: _6acda544,
    name: "agb___de"
  }, {
    path: "/de/benachrichtigungen",
    component: _60a548ca,
    name: "benachrichtigungen___de"
  }, {
    path: "/de/bibliothek",
    component: _984fb542,
    name: "bibliothek___de"
  }, {
    path: "/de/datenschutz",
    component: _3e2f7805,
    name: "datenschutz___de"
  }, {
    path: "/de/einstellungen",
    component: _45de6d1f,
    name: "einstellungen___de"
  }, {
    path: "/de/hilfe",
    component: _53ba4728,
    name: "hilfe___de"
  }, {
    path: "/de/impressum",
    component: _4d1a4fd9,
    name: "impressum___de"
  }, {
    path: "/de/login",
    component: _d8cc4a6a,
    name: "login___de"
  }, {
    path: "/de/profile",
    component: _29547010,
    name: "profiles___de"
  }, {
    path: "/de/raisenow",
    component: _7e4a7110,
    name: "raisenow___de"
  }, {
    path: "/de/registrieren",
    component: _1e8f5051,
    name: "registrieren___de"
  }, {
    path: "/de/team",
    component: _53ced02a,
    name: "team___de"
  }, {
    path: "/fr/404-path",
    component: _14d483a8,
    name: "404-path___fr"
  }, {
    path: "/fr/aide",
    component: _53ba4728,
    name: "hilfe___fr"
  }, {
    path: "/fr/bibliotheque",
    component: _984fb542,
    name: "bibliothek___fr"
  }, {
    path: "/fr/cgv",
    component: _6acda544,
    name: "agb___fr"
  }, {
    path: "/fr/confidentialite",
    component: _3e2f7805,
    name: "datenschutz___fr"
  }, {
    path: "/fr/impressum",
    component: _4d1a4fd9,
    name: "impressum___fr"
  }, {
    path: "/fr/login",
    component: _d8cc4a6a,
    name: "login___fr"
  }, {
    path: "/fr/notifications",
    component: _60a548ca,
    name: "benachrichtigungen___fr"
  }, {
    path: "/fr/parametres",
    component: _45de6d1f,
    name: "einstellungen___fr"
  }, {
    path: "/fr/profils",
    component: _29547010,
    name: "profiles___fr"
  }, {
    path: "/fr/raisenow",
    component: _7e4a7110,
    name: "raisenow___fr"
  }, {
    path: "/fr/registrieren",
    component: _1e8f5051,
    name: "registrieren___fr"
  }, {
    path: "/fr/team",
    component: _53ced02a,
    name: "team___fr"
  }, {
    path: "/pfad/ai-neu",
    component: _4d7acd91,
    name: "pfad-ai-neu___de___default"
  }, {
    path: "/pfad/neu",
    component: _4cf4d436,
    name: "pfad-neu___de___default"
  }, {
    path: "/de/pfad/ai-neu",
    component: _4d7acd91,
    name: "pfad-ai-neu___de"
  }, {
    path: "/de/pfad/neu",
    component: _4cf4d436,
    name: "pfad-neu___de"
  }, {
    path: "/fr/pfad/ai-nouveau",
    component: _4d7acd91,
    name: "pfad-ai-neu___fr"
  }, {
    path: "/fr/pfad/nouveau",
    component: _4cf4d436,
    name: "pfad-neu___fr"
  }, {
    path: "/de/pfad/:ref",
    component: _b9ca8222,
    name: "pfad-ref___de"
  }, {
    path: "/de/profil/:username?",
    component: _68028c30,
    name: "profil-username___de"
  }, {
    path: "/fr/pfad/:ref",
    component: _b9ca8222,
    name: "pfad-ref___fr"
  }, {
    path: "/fr/profil/:username?",
    component: _68028c30,
    name: "profil-username___fr"
  }, {
    path: "/de/pfad/:ref?/admin",
    component: _56ebda28,
    name: "pfad-ref-admin___de"
  }, {
    path: "/de/pfad/:ref?/editAdmin",
    component: _594b2582,
    name: "pfad-ref-editAdmin___de"
  }, {
    path: "/de/pfad/:ref?/vorschau",
    component: _68e14386,
    name: "pfad-ref-vorschau___de"
  }, {
    path: "/fr/pfad/:ref?/admin",
    component: _56ebda28,
    name: "pfad-ref-admin___fr"
  }, {
    path: "/fr/pfad/:ref?/editAdmin",
    component: _594b2582,
    name: "pfad-ref-editAdmin___fr"
  }, {
    path: "/fr/pfad/:ref/apercu",
    component: _68e14386,
    name: "pfad-ref-vorschau___fr"
  }, {
    path: "/pfad/:ref",
    component: _b9ca8222,
    name: "pfad-ref___de___default"
  }, {
    path: "/profil/:username?",
    component: _68028c30,
    name: "profil-username___de___default"
  }, {
    path: "/pfad/:ref?/admin",
    component: _56ebda28,
    name: "pfad-ref-admin___de___default"
  }, {
    path: "/pfad/:ref?/editAdmin",
    component: _594b2582,
    name: "pfad-ref-editAdmin___de___default"
  }, {
    path: "/pfad/:ref?/vorschau",
    component: _68e14386,
    name: "pfad-ref-vorschau___de___default"
  }, {
    path: "/",
    component: _6c1b9098,
    name: "index___de___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
